export default __webpack_public_path__ + "static/media/video-poster.43805890.jpg";